$(document).ready(function() {
  $(".banner-slider-homepage").owlCarousel({
    loop:true,
    margin:50,
    items:1,
    dots:false,
    nav: true,
    navText:["<button type='button' role='presentation' class='owl-prev owl-navigation'><span aria-label='Previous'><svg width='42' height='42' viewBox='0 0 42 42' fill='none' xmlns='http://www.w3.org/2000/svg'><rect x='-0.5' y='0.5' width='41' height='41' rx='20.5' transform='matrix(-1 0 0 1 41 0)' stroke='#E0E0E0'/><path d='M23.0436 25.5L18.0436 20.75L23.0436 16' stroke='white' stroke-linecap='round' stroke-linejoin='round'/></svg></span></button>","<button type='button' role='presentation' class='owl-next owl-navigation'><span aria-label='Next'><svg width='42' height='42' viewBox='0 0 42 42' fill='none' xmlns='http://www.w3.org/2000/svg'><rect x='0.500122' y='0.5' width='41' height='41' rx='20.5' stroke='#E0E0E0'/><path d='M18.9668 25.5L23.9668 20.75L18.9668 16' stroke='white' stroke-linecap='round' stroke-linejoin='round'/></svg></span></button>"],
    mouseDrag:false,
    touchDrag:false,
    autoplaySpeed: 500,
    autoplay:true,
    autoplayTimeout:8000
  });
  
  $(document).on('click', '.top-nav .quick-links .search-icon', function(){
    $('.itg_search_popup').slideToggle('active');
  });

  // $('.itg_search_icon').click(function(){
  //   $('.itg_search_popup').slideToggle('active');
  // });

 /* $('.itg--slide_main').slick({
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1099,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 839,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 639,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
}); */


   $('.itg--slide_main').slick({
  arrows: true,
  prevArrow:"<button type='button' class='slick-prev pull-left'><svg width='42' height='42' viewBox='0 0 42 42' fill='none' xmlns='http://www.w3.org/2000/svg'><rect x='-0.5' y='0.5' width='41' height='41' rx='20.5' transform='matrix(-1 0 0 1 41 0)' stroke='#E0E0E0'/><path d='M23.0436 25.5L18.0436 20.75L23.0436 16' stroke='white' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><svg width='42' height='42' viewBox='0 0 42 42' fill='none' xmlns='http://www.w3.org/2000/svg'><rect x='0.500122' y='0.5' width='41' height='41' rx='20.5' stroke='#E0E0E0'/><path d='M18.9668 25.5L23.9668 20.75L18.9668 16' stroke='white' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1099,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 849,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 599,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


     $('.itg_main_hightligh').slick({
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 849,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 599,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  

  $(document).on('click', 'header .hamburger .navbar-toggle', function(){
    $(this).parents('.nav-block-main').find('.main-nav').slideToggle();
  });

    Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  
  
  $(function() {
    var collection_sort = $('.list-sidebar').attr('data-default-sort');
   // alert(collection_sort);
    $('#SortBy_')
      // select the current sort order
      .val(collection_sort)
      .bind('change', function() {
        Shopify.queryParams.sort_by = jQuery(this).val();
        location.search = jQuery.param(Shopify.queryParams);
      }
    );
  });


  $(document).on('click', '.group-item', function() {
    let search = window.location.search;
    let collectionUrl = $('.list-sidebar').data('collection-url');
    if ($(this).hasClass('checked')) {
        $(this).removeClass('checked');
      } else {
        $(this).addClass('checked');
      }
      var activeTags = [];
      $('.group-item.checked').each(function (index, el) {
          var tag = $(el).attr('data-option');
  
          if (tag) {
              activeTags.push(tag);
          }
      });
    var tagsUrl = activeTags.join('+');
    console.log(tagsUrl);
    var newUrl = collectionUrl;
    if (tagsUrl) {
        newUrl += '/' + tagsUrl;
    }
    newUrl += search;
     console.log(newUrl);
    window.location = newUrl;
  });

  
  $('.collection .filter-group .selected .clear').click(function() {
    $(this).parents('.filter-group').find('.checked').removeClass('checked');
    
      var search = window.location.search;
      var collectionUrl = $('.list-sidebar').attr('data-collection-url');
        var activeTags = [];
        $('.group-item.checked').each(function (index, el) {
            var tag = $(el).attr('data-option');
      
            if (tag) {
                activeTags.push(tag);
            }
        });
      var tagsUrl = activeTags.join('+');
      console.log(tagsUrl);
      var newUrl = collectionUrl;
      if (tagsUrl) {
          newUrl += '/' + tagsUrl;
      }
      newUrl += search;
       console.log(newUrl);
      window.location = newUrl;
  });
  
  $('.collection .filter-group .group-title').click(function(){
    $(this).parents('.filter-group').find('.group-title').toggleClass('open');
    $(this).parents('.filter-group').toggleClass('open-hide');
  });

  $('.collection .list-filters .view-all').click(function() {
    $('.collection .group-items').show();
  });

  $('.list-filters .filter-group:last-child').addClass('open-hide');


  
  $(document).on('click','.mobileButton:not(.Active)', function() {
    $('.mobileSlide').slideUp();
    $(this).next('.mobileSlide').slideDown();
    $('.mobileButton').removeClass('Active');
    $(this).addClass('Active');
  });
  /**
  $(document).on('change','.product-form__input select', function() {
    var element = this;
    setTimeout (function() {

      // for only variant tabs js
     var SelectedVariantID = $(element).parents('.product__info-wrapper').find('input.product-variant-id').val();
      $('.VariantBasedFeatures').find('.VariantFeature[data-id='+SelectedVariantID+']').show().siblings().hide();


      
      $('.SwymGrHiddenSelect option').each(function() {
        var GetVariantID = $(this).attr('data-id');
        if (SelectedVariantID == GetVariantID) {
          var GetSKU = $(this).attr('data-sku');
          var GetTitle = $(this).attr('data-title').split('(');
          var GetID = $(this).attr('data-id');
          var GetPrice = $(this).attr('data-price');
          var GetComparePrice = $(this).attr('data-compare-price');
          var GetImageID = $(this).attr('data-img-id');
          console.log(GetSKU + ' - ' + GetTitle + ' - ' + GetID + ' - ' + GetPrice + ' - ' + GetComparePrice + ' - ' + GetImageID);
         
          var GetApprovveData = $(this).attr('data-approve');

          $(document).find('product-info').find('approve-button').attr('model',GetApprovveData);
          $(document).find('product-info').find('approve-button').attr('price',GetPrice);
          
          $(' .mediaSku').text(GetSKU);
          $('.itg--product-title h1 span').html(' - ' + GetTitle[0]);
        }
      });






      
    },250);
  });
  **/

  $(document).on('click', '.product-reviews .review-actions a', function(e){
    e.preventDefault();
    if(window.matchMedia("(min-width: 1024px)").matches){
      $('.Mainitg_tabs .itg_tab button').each(function(){
        var reviewText = $(this).text();
        console.log(reviewText);
        if(reviewText == 'Reviews'){
          $(this).addClass('itg--tabOpen');
          $(this).trigger('click');
          $('html, body').animate({
            scrollTop: $('#Reviews').offset().top
          }, 500);
        }
      });
    }else{
    $('.Mainitg_tabs .itg_tabcontent').each(function(){
      var revText = $(this).attr('id');
      console.log(revText);
      if(revText == 'Reviews'){
        $(this).find('.mobileSlide').slideDown();
        $(this).find('.mobileButton').addClass('Active');
        $('html, body').animate({
          scrollTop: $('#Reviews').offset().top
        }, 500);
      }
    });
    }
  });

  $(document).on('click', '.Mainitg_tabs .itg_tab button', function(){
    $('button.itg_tablinks').removeClass('itg--tabOpen');
  });



  

  $('.SwymGrPopUp').magnificPopup({
      type:'image',
      gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1] // Will preload 0 - before current, and 1 after the current image
      }
  });

  $(document).ready(function() {
	$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
		disableOn: 250,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,

		fixedContentPos: false
	});
});
  



   $(".itg_tab_list span").click(function(e) {
        var tabName = $(this).attr('data-id');
        $(this).addClass('active_tabs').siblings().removeClass('active_tabs');
        $('.itg_tab_details .itg_tab_content').each(function() {
            var tabName_box = $(this).attr('data-id');
            if (tabName_box == tabName) {
              $(this).addClass('itg_active_content');
            }else{
              $(this).removeClass('itg_active_content');
            }
        })
    });



  

 

  
  
  // $("#zoom_03").elevateZoom({
  //   // gallery:'gallery_01',
  //   cursor: 'pointer',
  //   easing : true,
  //   // galleryActiveClass: 'active',
  //   imageCrossfade: true,
  //   loadingIcon: 'https://www.elevateweb.co.uk/spinner.gif'
  // });

  var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        if (links[i].classList.contains('anti-stupidity') || links[i].closest('.anti-stupidity')) continue;
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener nofollow';
      }
    }


    if ($(document).find('.removeWhenSingleVariant').length) {

            $(document).find('.MainMediaWrapper .SwymGrMediaVariant:first-child').css('display','block').siblings().hide();
            $(document).find('.ThumbMediaWrapper .SwymGrMediaVariant:first-child').addClass('ActiveMediaThumb').siblings().removeClass('ActiveMediaThumb');
  
      
    } else {
      
      $(document).find('.MainMediaWrapper .SwymActiveWrap .SwymGrMediaVariant:first-child').css('display','block').siblings().hide();
        $(document).find('.ThumbMediaWrapper .SwymActiveWrap .SwymGrMediaVariant:first-child').addClass('ActiveMediaThumb').siblings().removeClass('ActiveMediaThumb');
      setTimeout (function() {
        $(document).find('.MainMediaWrapper .SwymActiveWrap .SwymGrMediaVariant:first-child').css('display','block').siblings().hide();
        $(document).find('.ThumbMediaWrapper .SwymActiveWrap .SwymGrMediaVariant:first-child').addClass('ActiveMediaThumb').siblings().removeClass('ActiveMediaThumb');
      }, 1000);
      setTimeout (function() {
        $(document).find('.MainMediaWrapper .SwymActiveWrap .SwymGrMediaVariant:first-child').css('display','block').siblings().hide();
        $(document).find('.ThumbMediaWrapper .SwymActiveWrap .SwymGrMediaVariant:first-child').addClass('ActiveMediaThumb').siblings().removeClass('ActiveMediaThumb');
      }, 4000);
    
    }


  
  $(document).on('click','.SwymGrMediaVariant', function() {
    var thisID = $(this).attr('data-id');
    $(this).addClass('ActiveMediaThumb').siblings().removeClass('ActiveMediaThumb');
    $(document).find('.MainMediaWrapper .SwymGrMediaVariant[data-id="'+thisID+'"]').css('display','block').siblings().hide();
  });

  $(document).on('change','.product-form__input select', function() {
    
    setTimeout (function() {
      console.log('Changed');
      var SelectedID = $('product-form form input[name="id"]').attr('value');
       console.log('Changed - ' + SelectedID);
      $(document).find('.MainMediaWrapper .MediaRow[data-id="'+SelectedID+'"]').css('display','block').addClass('SwymActiveWrap').siblings().removeClass('SwymActiveWrap').hide();
  
      $(document).find('.ThumbMediaWrapper .MediaRow[data-id="'+SelectedID+'"] .SwymGrMediaVariant:first-child').addClass('ActiveMediaThumb').siblings().removeClass('ActiveMediaThumb');

      // $(document).find('.MainMediaWrapper .MediaRow[data-id="'+SelectedID+'"]').parents('.MainMediaWrapper').addClass('SwymActiveWrap');
      // SwymActiveWrap
      $(document).find('.MainMediaWrapper .MediaRow.SwymActiveWrap .SwymGrMediaVariant:first-child').css('display','block').siblings().hide();
      $(document).find('.ThumbMediaWrapper .MediaRow[data-id="'+SelectedID+'"]').css('display','flex').addClass('SwymActiveWrap').siblings().removeClass('SwymActiveWrap').hide();
    },100);
  });

  
  

});


$(document).ready(function(){
  var sidebarHeight = Number($('.sidebar').height());
  
  sidebarHeight += 260;
  $('#MainContent').css('min-height', sidebarHeight);
  // console.log(sidebarHeight);

  if(window.matchMedia("(max-width: 1023px)").matches){
    var sideBarContent = $('.sidebar').html();
    console.log(sideBarContent);
    if(sideBarContent != undefined && sideBarContent != ''){
      $('#MainContent').append('<div class="sidebar vk--mobile-sidebar">' + sideBarContent + '</div>');
    }
  }
});



$(window).on('load', function(){
  var sidebarHeight = Number($('.sidebar').height());
  
  sidebarHeight += 260;
  $('#MainContent').css('min-height', sidebarHeight);
  console.log(sidebarHeight);
});

$(window).on('load', function(){
  setTimeout (function() {
    $('.product__media-list .product__media-item').each(function(){
      var mainImage = $(this).attr('data-img-name');
      var dataMediaId = $(this).attr('data-media-id');
      console.log(mainImage)
      $('.zoomWindow').each(function(){
        var zoomImage = $(this).css('background-image');
        console.log(zoomImage)
        if(zoomImage.indexOf (mainImage) != -1){
          console.log('Matched')
          $(this).parents('.zoomContainer').attr('data-id', dataMediaId);
        }
      });
    });
  }, 5500);

  $(document).on('mouseover', '.product__media-item .product__media', function(){
    var dataMedia = $(this).parents('.product__media-item').attr('data-media-id');
    $('.zoomContainer').each(function(){
      var dataId = $(this).attr('data-id');
      if(dataMedia == dataId){
        $(this).css('display', 'block');
      }else{
        $(this).css('display', 'none');
      }
    });
  });

  
});


 $(document).ready(function(){
  var pageHref = $(location).attr('href');
  console.log(pageHref);
  
    if(pageHref.indexOf('/pages') != -1){
      if(pageHref.indexOf('-1') != -1){
        pageHref = pageHref.replace('-1', '');
        window.location.href = pageHref;
        $('body').addClass('Added');
      }else{
        
      }
  }
});


//predictive search 
    //$('form[action="/search"]').css('position', 'relative').each(function () {
      
    //var input = $(this).find('input[name="q"]');
    //var offSet = input.position().top + input.innerHeight();
    //$('<ul class="search-results"></ul>').css({'position': 'absolute','left': '0px','top': offSet}).appendTo($(this)).hide();

    //input.attr('autocomplete', 'off').bind('keyup change', function () {
      //var term = $(this).val();
      //var form = $(this).closest('form');
      //var resultsList = form.find('.search-results');
//// alert();
      //jQuery.getJSON("/search/suggest.json", {
        //"q": term,
        //"resources": {
          //"type": "product",
          //"limit": 4,
          //"options": {
            //"unavailable_products": "hide",
            //"fields": "title,product_type,variants.title,tag,variants.sku"
          //}
        //}
      //}).done(function (response) {

        //resultsList.empty();

         //console.log("Response data: " + JSON.stringify(response, null, 2));

        //var productSuggestions = response.resources.results.products;

        //if (productSuggestions.length > 0) {

          //$.each(productSuggestions, function (index, item) {
            //var link = $('<a></a>').attr('href', item.url);
            //link.append('<div class="itg_thumbnail"><img src="' + item.image + '" /></div>');
            //link.append('<div class="itg_prouct_data"><h3 class="title">' +item.title + '</h3> <span class="price">' +'$'+item.price + '</span></div>');
            ////link.append('<span class="price">' +'$'+item.price + '</span>');
            ////link.wrap('<div class="itg_prouct_data"></div>');
            //link.wrap('<li></li>');
            //resultsList.append(link.parent());
          //});
          //resultsList.fadeIn(100);
        //} else {
          //resultsList.html('<li><span class="title">No results.</span></li>');           
        //}
      //});

    //});
  //});
  //$('body').bind('click', function () {
    //$('.search-results').hide();
  //});

// End of Predictive search

